import { atomWithStorage } from 'jotai/utils';
import { LOCAL_STORAGE } from '@/functions/constants/enums';

export const titleAtom = atomWithStorage<string>(LOCAL_STORAGE.TITLE.KEY, '');
